import { useQuery } from '@tanstack/react-query';
import { getTenantConfig } from '@/services/tenants';

export const useTenantInsurerDialogContact = (siteType: string) => {
  const { data, isLoading, isFetching, isError, isPending, refetch, error } = useQuery({
    queryKey: ['tenantConfig', siteType, 'insurerDialogMessages'],
    queryFn: () => getTenantConfig(siteType),
    enabled: !!siteType,
    staleTime: 5 * 60 * 1000,
  });

  return { data, isLoading, isFetching, isError, isPending, refetch, error };
};
